import React, { useContext, useState, useRef, useEffect } from "react";
import { StaffContext } from "../../../Context";
import Lang from "./Lang";
import "./PremiumStaffSelect.css";

const Avatar = ({ user, colorIndex }) => {

  const colors = [
    "#115e59", // Teal 800
    "#0f766e", // Teal 700
    "#0d9488", // Teal 600
    "#1e293b", // Slate 800
    "#334155", // Slate 700
    "#475569", // Slate 600
  ];

  const bgColor = colors[colorIndex % colors.length];

  if(!user) return <div></div>
    console.log(user);
  if (user && user.image) return (
  
    <div
      className="staff-avatar"
    >
       <Avatar
          alt={user.name}
          src={`/images/${user.image}`}
      />
    </div>
  );

  const initials = user.name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  

  return (
    <div className="staff-avatar" style={{ backgroundColor: bgColor }}>
      {initials}
    </div>
  );
};

export default function PremiumStaffSelect({ value, setValue, label }) {
  const { staff } = useContext(StaffContext);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const selectedStaff = staff.find((s) => s._id === value);

  const filteredStaff = staff
    .filter((s) => s.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="premium-select-container" ref={dropdownRef}>
      <label className="premium-select-label">
        <Lang w={label} />
      </label>
      <div
        className={`premium-select-trigger ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedStaff ? (
          <div className="selected-item">
            <Avatar user={selectedStaff} colorIndex={staff.indexOf(selectedStaff)} />
            <div className="selected-text">
              <div className="staff-name">{selectedStaff.name}</div>
              <div className="staff-role-meta">{selectedStaff.email || "Staff Member"}</div>
            </div>
          </div>
        ) : (
          <span className="placeholder">Select a staff member...</span>
        )}
        <div className={`chevron ${isOpen ? "up" : "down"}`}>▾</div>
      </div>

      {isOpen && (
        <div className="premium-dropdown">
          <input
            type="text"
            className="dropdown-search"
            placeholder="Search staff..."
            autoFocus
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          />
          <div className="dropdown-list">
            {filteredStaff.map((s, idx) => (
              <div
                key={s._id}
                className={`dropdown-item ${s._id === value ? "selected" : ""}`}
                onClick={() => {
                  setValue(s._id);
                  setIsOpen(false);
                  setSearchTerm("");
                }}
              >
                <Avatar user={s} colorIndex={staff.indexOf(s)} />
                <div className="staff-info">
                  <div className="staff-name">{s.name}</div>
                  <div className="staff-role-meta">{s.roles.slice(0,3).toString()}</div>
                </div>
              </div>
            ))}
            {filteredStaff.length === 0 && (
              <div className="no-results">No staff found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
